import './DAcConfirmation.css';
import React from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { get } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import Cookies from 'js-cookie';
const DAcConfirmation = _ref => {
  let {
    fields,
    params,
    rtl
  } = _ref;
  console.log(fields);
  const {
    data: {
      configuration: {
        buttonLabel,
        buttonUrl,
        description,
        image,
        shortDescription,
        title,
        contentTitle
      }
    }
  } = fields;
  const APPLICATION_ID = 'applicationNumber';
  const imageField = get(image, 'jss.value') || {};
  const appNumber = Cookies.get(APPLICATION_ID) || '---';
  const descriptionWithNumber = {
    value: (get(description, 'jss.value') || '').replace('$number$', appNumber)
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: fullWidthStyles
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "title h1",
    field: get(title, 'jss')
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "description",
    field: get(shortDescription, 'jss')
  })), /*#__PURE__*/React.createElement("div", {
    className: `confirmation-banner ${fullWidthStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "confirmation-banner__image",
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 991px)",
    srcSet: `${imageField.src}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${imageField.src}`,
    alt: imageField.alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "confirmation-banner__content"
  }, /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "h5 confirmation-banner__title",
    field: get(contentTitle, 'jss')
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "confirmation-banner__description",
    field: descriptionWithNumber
  }), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: get(buttonUrl, 'jss.value.href')
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn btn-secondary"
  }, get(buttonLabel, 'jss.value'))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `   ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default DAcConfirmation;
const commonStyles = "c1b3x4e1";
const fullWidthStyles = "fc3eaxr";
const rtlStyles = "r1n30ioe";
const ltrStyles = "lnpb00q";